export const DAILY = 'daily';
export const MONTHLY = 'monthly';
export const DATE_FORMAT1 = 'MMMM, YYYY';
export const DATE_FORMAT2 = 'll';
